export class NumberModel {
  msisdn: string;
  partOfOne: string;
  partOfTwo: string;
  partOfThree: string;
  partOfFour: string;
  otpExpMin: number;
  tryingOtp: boolean;
  notAllowedMSISDN: boolean;
  pinSuspend: boolean;
}
